import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from "dayjs";
import "./filter-options-select.scss"
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
interface CustomDateRangePickerProps {
  onDateRangeChange: (from: Dayjs | null, to: Dayjs | null) => void;
  startDateError?: string;
  endDateError?: string;
  setFromDate: (date: Dayjs | null) => void;
  setToDate: (date: Dayjs | null) => void;
  fromDate?: any;
  toDate?: any
}


const CustomDateRangePicker: React.FC<CustomDateRangePickerProps> = ({
  onDateRangeChange,
  startDateError,
  endDateError,
  setFromDate,
  setToDate,
  fromDate,
  toDate
}) => {
  const [fromDateLocal, setFromDateLocal] = useState<Dayjs | null>(fromDate ?? null);
  const [toDateLocal, setToDateLocal] = useState<Dayjs | null>(toDate ?? null);

  // Sync props with local state when props change (from activeFilters)
  useEffect(() => {
    setFromDateLocal(fromDate ?? null);
    setToDateLocal(toDate ?? null);
  }, [fromDate, toDate]);

  const handleFromDateChange = (newValue: Dayjs | null) => {
    setFromDateLocal(newValue);
    setFromDate(newValue);
    onDateRangeChange(newValue, toDateLocal);
  };

  const handleToDateChange = (newValue: Dayjs | null) => {
    setToDateLocal(newValue);
    setToDate(newValue);
    onDateRangeChange(fromDateLocal, newValue);
  };

  return (
    <div className="filter-select-input-wrapper">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box display="flex" alignItems="flex-start" gap={2} mt={2}>
          <Box display="flex" flexDirection="column" flex={1}>
            <DesktopDatePicker
              label="From Date"
              value={fromDateLocal}
              onChange={handleFromDateChange}
              minDate={dayjs('1900-01-01')}
              maxDate={toDateLocal ??dayjs()}
              disableFuture
              shouldDisableDate={(date) =>
                !!(toDate && date.isAfter(toDate)) || date.isAfter(dayjs())
              }
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  sx: {
                    "& .MuiInputBase-input": {
                      fontSize: "14px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px",
                    },
                  },
                },
              }}
            />
            {startDateError && (
              <div className="error-text" style={{ marginTop: "4px" }}>{startDateError}</div>
            )}
          </Box>
          <Box display="flex" flexDirection="column" flex={1}>
            <DesktopDatePicker
              label="To Date"
              value={toDateLocal}
              onChange={handleToDateChange}
              minDate={
                fromDateLocal && fromDateLocal.isBefore(dayjs('1900-01-01'))
                  ? dayjs('1900-01-01')
                  : fromDateLocal ?? undefined
              }
              maxDate={dayjs()}
              disableFuture
              shouldDisableDate={(date) =>
                !!(fromDate && date.isBefore(fromDate)) || date.isAfter(dayjs())
              }
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  sx: {
                    "& .MuiInputBase-input": {
                      fontSize: "14px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px",
                    },
                  },
                },
              }}
            />
            {endDateError && (
              <div className="error-text" style={{ marginTop: "4px" }}>{endDateError}</div>
            )}
          </Box>
        </Box>
      </LocalizationProvider>
    </div>
  );
};


export default CustomDateRangePicker;